<template>
  <div>
    <div class="grid-content maintitle">
      <span>用户数据详情</span>
    </div>
    <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false">
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont">&#xe667;</i>
              {{ $t("message.刷新") }}
            </el-button>
          </el-link>
        </div>
      </div>
    </div>

    <div class="grid-content subtitle">
      <span>用户基本信息</span>
    </div>
    <div class="grid-content content-margin">
      <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel">用户ID</span>
          </td>
          <td width="600px">
            <el-input
              v-model="info.user.userID"
              readonly
              size="mini"
              placeholder=""
            >
            </el-input>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">Email</span>
          </td>
          <td>
            <el-input readonly v-model="info.user.email" size="mini" />
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">访问来源</span>
          </td>
          <td>
            <el-input readonly v-model="info.user.email" size="mini" />
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">访问数量</span>
          </td>
          <td>
            <el-input readonly v-model="info.accessCount" size="mini" />
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">访问时长</span>
          </td>
          <td>
            <el-input readonly v-model="info.accessTime" size="mini" />
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">平均阅读完成率</span>
          </td>
          <td>
            <el-input readonly v-model="info.completionRate" size="mini" />
          </td>
        </tr>
      </table>
    </div>
    <div class="grid-content subtitle">
      <span>访问轨迹</span>
    </div>
    <div class="grid-content content-margin">
      <el-table
        :data="info.eventList"
        ref="table"
        stripe
        border
        :max-height="tableHeight"
        style="width: 100%"
      >
        <!-- <el-table-column fixed label="No." type="index" width="55">
        </el-table-column> -->

        <el-table-column
          min-width="400"
          sortable
          prop="data3"
          label="文章/视频/pdf唯一ID"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="createDate"
          label="时间"
          min-width="450"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { topfixfunc } from "@/utils/topFix";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import commonUtil from "@/utils/commonUtil";

export default {
  name: "UserDetail",
  components: {},
  data() {
    return {
      tableHeight: 500,

      info: {
        user: {
          userID: "",
          email: "",
        },
      },
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;
      };
    });
  },
  watch: {},
  methods: {
    goBack() {
      this.$router.go(-1); //返回上一层
    },

    refresh() {
      rejecthttp(
        true,
        "get",
        "/manage/user/useraccesshistory",
        {
          userid: this.info.user.userID,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.info = doc.data.data;
            this.info.eventList.forEach((any) => {
              any.createDate = commonUtil.formatDate(any.createDate);
            });

            console.log(this.info);
          }
        }
      );
    },
  },
  created() {
    if (this.$route.query.id) {
      this.info.user.userID = this.$route.query.id;
    }
    console.log("userid=", this.info.user.userID);
    this.refresh();
  },
  computed: {},
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
.serch-box {
  margin-top: -15px;
}
/* .seek-box /deep/.serch{
  top:0 !important;
} */

.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}

.seek-box {
  position: absolute;
  width: 330px;
  height: 40px;
  top: -42px;
  right: 0px;
  z-index: 10;
}

.seek-box /deep/ .el-input__inner {
  height: 35px;
}
seek-main {
  width: 80%;
  height: 40px;
  font-size: 14px;
  color: #888;
  border: none;
}

.seek-icon {
  font-size: 28px;
  cursor: pointer;
  color: #303133;
  position: relative;
  top: 5px;
  margin-left: 0.1em;
}

.flex-b {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/vipcenter/UserDetail.vue